const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Viewables Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Viewables', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/viewables/:subresource', null, {
    archived: {params: {subresource: 'archived'}, method: 'GET', isArray: false},
    titles: {params: {subresource: 'titles'}, method: 'POST', isArray: true},
    archive: {params: {subresource: 'archive'}, method: 'POST', isArray: false},
    unarchive: {params: {subresource: 'unarchive'}, method: 'POST', isArray: false}
  });

}]);